import { Body1 } from '@flatsy/core/MaterialUi/Typo'
import React, { useState, useEffect, useContext } from 'react'
import i18n from '@flatsy/utils/translations'
import RequiredItem from './Item'
import useStyles from './Style'
import ArrowStep3 from '../../Arrow/Step3'
import { FileContext } from '../../../Context'

const Required: React.FC = () => {
  const classes = useStyles()
  const [showArrow, setShowArrow] = useState(false)
  const {
    applicants: { current },
    Uppy,
  } = useContext(FileContext)

  useEffect(() => {
    if (Uppy?.formatedFiles && Object.keys(Uppy?.formatedFiles).length > 0) {
      setTimeout(() => {
        setShowArrow(true)
      }, 30)
    }
  }, [Uppy?.formatedFiles])

  if (!current || !current.required_uploads) {
    return <></>
  }

  return (
    <div className={classes.container}>
      <Body1 className={classes.title}>{i18n.t('documents_requested')}</Body1>
      {current.required_uploads.map((required, key) => (
        <RequiredItem key={key} mainKind={required} />
      ))}
      <ArrowStep3 show={showArrow} />
    </div>
  )
}

export default Required
